import { userService } from '../services';
import router from '../router';
import { User } from '@/models';

const user = JSON.parse(localStorage.getItem('user') || 'null');
const state = {
  status: {
    loggedIn: user
  },
  user: user,
  users: [],
  solvers: [],
  otherSolvers: [],
  totalCount: 0,
  search: {
    pageRows: 10,
    actualPage: 1,
    orderBy: '',
    orderByAsc: false,
    onlyActive: false,
    filter: {
      onlyActive: false
    }
  }
};

const actions = {
  getAll({ dispatch, commit }: any, searchQuery: any) {
    commit('saveSearchQuery', searchQuery);

    userService
      .getAll(searchQuery)
      .then(
        users => commit('getAllSuccess', users),
        error => console.log(error)
      )
      .finally();
  },
  getSolvers({ dispatch, commit }: any, facultyId: number) {
    userService
      .getSolvers(facultyId)
      .then(
        users => commit('getSolversSuccess', users),
        error => console.log(error)
      )
      .finally();
  },
  getOtherSolvers({ dispatch, commit, getters }: any, userName: string) {
    const solvers = getters.otherSolvers();

    if (!solvers || solvers.length === 0) {
      userService
        .getOtherSolvers(userName)
        .then(
          users => commit('getOtherSolversSuccess', users),
          error => console.log(error)
        )
        .finally();
    }
  },
  getUser({ commit }: any) {
   return userService.getUser().then(response=>{
    commit('getUser', response);
    return response;
   });
  },
  passwordReset({ dispatch, commit }: any, { form }: any) {
    userService.passwordReset(form.username.value).then(
      user => {
        dispatch('alert/success', 'notification.passwordReset', {
          root: true
        });
      },
      error => {
        dispatch('alert/error', 'notification.passwordResetError', { root: true });
      }
    );
  },
  passwordNew({ dispatch, commit }: any, { form, resetToken, userKey }: any) {
    userService.passwordNew(form.newPassword.value, resetToken, userKey).then(
      user => {
        dispatch('alert/success', 'notification.passwordUpdated', {
          root: true
        });

        router.push('/prihlaseni');
      },
      error => {
        form.newPassword.errorMessage = 'notification.passwordUnableChange';
        dispatch('alert/error', form.newPassword.errorMessage, { root: true });
      }
    );
  },
  logout({ commit }: any) {
    userService.logout();
    commit('logout');
  },
  createUser({ dispatch }: any, { newUser }: any) {
    userService
      .createUser(newUser)
      .then(
        () => {
          dispatch('alert/success', 'notification.userCreated', {
            root: true
          });
        },
        error => {
          dispatch('alert/error', JSON.stringify(error), {
            root: true
          });
        }
      )
      .finally(() => dispatch('getAll', state.search));
  },
  updateUser({ dispatch }: any, { userName, user }: any) {
    userService
      .updateUser(userName, user)
      .then(
        () => {
          dispatch('alert/success', 'notification.userUpdated', {
            root: true
          });
        },
        error => {
          dispatch('alert/error', JSON.stringify(error), {
            root: true
          });
        }
      )
      .finally(() => dispatch('getAll', state.search));
  },
  updateAccount({ dispatch, commit }: any, { userName, user }: any) {
    userService
      .updateUser(userName, user)
      .then(
        () => {
          commit('updateAccountSuccess', user);
          dispatch('alert/success', `Uživatel byl upraven.`, {
            root: true
          });
        },
        error => {
          dispatch('alert/error', JSON.stringify(error), {
            root: true
          });
        }
      )
      .finally(() => dispatch('getAll', state.search));
  }
};

const mutations = {
  getAllSuccess(state: any, users: any) {
    state.totalCount = users.totalCount;
    state.users = users;
  },
  getSolversSuccess(state: any, users: any) {
    state.solvers = users;
  },
  getOtherSolversSuccess(state: any, users: any) {
    state.otherSolvers = users;
  },
  getUser(state: any, user: any) {
    state.status = { loggedIn: true };
    state.user = user;
  },
  loginSuccess(state: any, user: any) {
    state.status = { loggedIn: true };
    state.user = user;
  },
  loginFailure(state: any) {
    state.status = { loggedIn: false };
    state.user = null;
  },
  logout(state: any) {
    state.status = { loggedIn: false };
    state.user = null;
  },
  saveSearchQuery(state: any, searchQuery: any) {
    state.search = searchQuery;
  },
  updateAccountSuccess(state: any, user: any) {
    state.user.user.firstName = user.firstName;
    state.user.user.lastName = user.lastName;
    state.user.user.preferredCultureCode = user.preferredCultureCode;
  }
};

const getters = {
  getUsers: (state: any, getters: any) => () => {
    return state.users;
  },
  getTotalCount: (state: any, getters: any) => () => {
    return state.totalCount;
  },
  otherSolvers: (state: any, getters: any) => () => {
    return state.otherSolvers;
  }
};

export const account = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
